export const LAMBDATEST_PROMO_BANNER_HEIGHT = 'LAMBDATEST_PROMO_BANNER_HEIGHT';
